import {
  Disclaimer,
  lightTheme,
  Pill,
  SupportTicketStatus,
  ticketStatusLabel,
} from '@vgrubs/components';
import { statusPillColor } from '../helpers/supportTicketLabels';

/**
 * Where a ticket stands, drawn the same way in the list and in the detail:
 * white on a solid fill, like every other status in the admin (see
 * `DeliveryStatusPill`), and in the admin's words rather than the merchant's.
 */
export const TicketStatusPill = ({
  status,
}: {
  status: SupportTicketStatus;
}) => (
  <Pill $background={statusPillColor(status)}>
    <Disclaimer $m="0" $color={lightTheme.white} $semiBold $lineHeight="1">
      {ticketStatusLabel(status, 'admin')}
    </Disclaimer>
  </Pill>
);
